module.exports = __webpack_public_path__ + "img/trud_legal.966c07b7.png";